module.exports = __webpack_public_path__ + "img/女生头像.97c38468.png";